// @generated by scripts/generate-graphql-cache-entity-resolver-schema.ts — do not edit.

export const entityResolverSchema = {
  CompleteMutationRoot: {
    createSavedView: {
      targets: ['GraphqlSavedView'],
      argumentPaths: [
        ['input', 'id'],
        ['input', 'sharedTeamId'],
      ],
    },
    markEmailThreadSeen: {
      targets: ['GraphqlSoupEmailThread'],
      argumentPaths: [['input', 'threadId']],
    },
    markEmailThreadUnread: {
      targets: ['GraphqlSoupEmailThread'],
      argumentPaths: [['input', 'threadId']],
    },
    recordChannelActivity: {
      targets: ['GraphqlChannelActivity'],
      argumentPaths: [['input', 'channelId']],
    },
    resolveEmailMessageOperation: {
      targets: ['GraphqlSoupEmailThread'],
      argumentPaths: [['input', 'messageId']],
    },
    setEmailThreadArchived: {
      targets: ['GraphqlSoupEmailThread'],
      argumentPaths: [['input', 'threadId']],
    },
    setEmailThreadState: {
      targets: ['GraphqlSoupEmailThread'],
      argumentPaths: [['input', 'threadId']],
    },
    setEntityProperty: {
      targets: ['GraphqlProperty'],
      argumentPaths: [
        ['input', 'propertyDefinitionId'],
        ['input', 'value', 'entityReference', 'specificMessageId'],
        ['input', 'value', 'selectOption'],
      ],
    },
    updateEmailThreadLabel: {
      targets: ['GraphqlSoupEmailThread'],
      argumentPaths: [
        ['input', 'labelId'],
        ['input', 'threadId'],
      ],
    },
    updateInitiative: {
      targets: ['GraphqlSoupInitiative'],
      argumentPaths: [['initiativeId']],
    },
    updateSavedView: {
      targets: ['GraphqlSavedView'],
      argumentPaths: [
        ['input', 'id'],
        ['input', 'sharing', 'teamId'],
      ],
    },
  },
  GraphqlUser: {
    agentSession: {
      targets: ['GraphqlSoupAgentSession'],
      argumentPaths: [['sessionId']],
    },
    emailThread: {
      targets: ['GraphqlSoupEmailThread'],
      argumentPaths: [['input', 'threadId']],
    },
    initiative: {
      targets: ['GraphqlSoupInitiative'],
      argumentPaths: [['initiativeId']],
    },
    savedView: {
      targets: ['GraphqlSavedView'],
      argumentPaths: [['id']],
    },
    soupEntity: {
      targets: [
        'GraphqlSoupAgentSession',
        'GraphqlSoupCalendarEvent',
        'GraphqlSoupCall',
        'GraphqlSoupChannel',
        'GraphqlSoupChannelMessage',
        'GraphqlSoupChat',
        'GraphqlSoupCrmCompany',
        'GraphqlSoupCrmContact',
        'GraphqlSoupDatabaseRow',
        'GraphqlSoupDocument',
        'GraphqlSoupEmailThread',
        'GraphqlSoupForeignEntity',
        'GraphqlSoupInitiative',
        'GraphqlSoupProject',
        'GraphqlSoupReminder',
      ],
      argumentPaths: [['input', 'entityId']],
    },
  },
} as const;

export type GeneratedEntityResolverSchema = typeof entityResolverSchema;
export type GeneratedEntityResolverTarget =
  | 'GraphqlChannelActivity'
  | 'GraphqlProperty'
  | 'GraphqlSavedView'
  | 'GraphqlSoupAgentSession'
  | 'GraphqlSoupCalendarEvent'
  | 'GraphqlSoupCall'
  | 'GraphqlSoupChannel'
  | 'GraphqlSoupChannelMessage'
  | 'GraphqlSoupChat'
  | 'GraphqlSoupCrmCompany'
  | 'GraphqlSoupCrmContact'
  | 'GraphqlSoupDatabaseRow'
  | 'GraphqlSoupDocument'
  | 'GraphqlSoupEmailThread'
  | 'GraphqlSoupForeignEntity'
  | 'GraphqlSoupInitiative'
  | 'GraphqlSoupProject'
  | 'GraphqlSoupReminder';
export type GeneratedEntityResolverArgumentPath =
  | readonly ['id']
  | readonly ['initiativeId']
  | readonly ['input', 'channelId']
  | readonly ['input', 'entityId']
  | readonly ['input', 'id']
  | readonly ['input', 'labelId']
  | readonly ['input', 'messageId']
  | readonly ['input', 'propertyDefinitionId']
  | readonly ['input', 'sharedTeamId']
  | readonly ['input', 'sharing', 'teamId']
  | readonly ['input', 'threadId']
  | readonly ['input', 'value', 'entityReference', 'specificMessageId']
  | readonly ['input', 'value', 'selectOption']
  | readonly ['sessionId'];
